import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import Moment from 'moment';
import Datetime from 'react-datetime';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import Avatar from 'components/avatar';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import Input from 'components/react-validation/components/input';
import Submit from '../../components/react-validation/components/submit';
import * as Vali from 'helper/validator-helper';
import Form from 'components/react-validation/components/form';
import PhoneNumberInput from 'components/PhoneNumberInput';
import * as LotActionType from '../constants';
import Translate from 'components/translate';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';

class EditCurrentOwnership extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    lotProfile: PropTypes.object,
    LotProfile: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      purchaseDate: props.lotProfile.lotOwnerships[0].purchaseDate
        ? Moment(props.lotProfile.lotOwnerships[0].purchaseDate).format(
            'MM/DD/YYYY'
          )
        : null,
      email: '',
      emailCheckType: null,
      userData: null,
      disabledClassBtn: '',
      isSettingNewOwner: false,
      isFocusPurchaseDate: false,
      dateError: null,
      ctxMenuList: {},
      ctxMenuList2: {},
      enableHomeownerRequest: false,
      setPrimaryOwner: false,
      openSelectCheckBox: false,
      contextMenuPrimaryKey: false,
      homeownerInvitation: true,
      isDisplayHOInvitationModal: false,
    };
  }

  componentDidMount() {
    // document.addEventListener('click', this.handleCloseContextMenu);
    const self = this;
    window.addEventListener('click', (e) => {
      if (
        document.getElementById('box') &&
        document.getElementById('box').contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById('select-list-current-ownership') &&
          document
            .getElementById('select-list-current-ownership')
            .contains(e.target)
        ) {
          // clicked in box
        } else {
          self.setState({ ctxMenuList: {} });
        }
        if (
          document.getElementById('select-list-current-ownership2') &&
          document
            .getElementById('select-list-current-ownership2')
            .contains(e.target)
        ) {
          //clicked in box
        } else {
          self.setState({ ctxMenuList2: {} });
        }
      }
    });
  }

  // componentWillUnmount() {
  //   document.removeEventListener('click', this.handleCloseContextMenu);
  // }

  // handleCloseContextMenu = event => {
  //   if (this.ctxMenu && !this.ctxMenu.contains(event.target) && (Object.keys(this.state.ctxMenuList).length !== 0)) {
  //     this.setState({
  //       ctxMenuList: {}
  //     });
  //   }
  //   if (this.ctxMenu && !this.ctxMenu.contains(event.target) && (Object.keys(this.state.ctxMenuList2).length !== 0)) {
  //     this.setState({
  //       ctxMenuList2: {}
  //     });
  //   }
  // }

  onBindingLot = () => {
    this.props.dispatch({
      type: LotActionType.GET_LOT_BY_ID_ASYNC,
      params: this.props.lotProfile.id,
      callback: () => {
        this.setState({
          isSettingNewOwner: false,
          emailCheckType: null,
          email: '',
        });
      },
    });
  };

  toolTip() {
    return (
      <Tooltip id='set-new-ownership-tooltip' className='in tooltip-siteone'>
        <span>
          If the email address does not appear to be your{' '}
          <Translate translateKey='homeowner' />, we will send an invitation to
          the <Translate translateKey='homeowner' /> to activate their account
          under your domain.
        </span>
      </Tooltip>
    );
  }

  onCustomAction = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    this.props.history.push(
      this.props.location.pathname + `?active=${queryParams.get('active')}`
    );
  };

  onValidateEmail = (value) => {
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
    if (emailPattern.test(value.trim())) {
      return true;
    }
    return false;
  };

  onChangeEmail = (e) => {
    this.setState({
      email: e.target.value,
    });
  };

  onChangePurchaseDate = (purchaseDate) => {
    if (typeof purchaseDate === 'string') {
      this.setState({ purchaseDate });
      if (
        Moment(purchaseDate, 'MM/DD/YYYY', true).isValid() ||
        purchaseDate === ''
      ) {
        this.setState({ dateError: null });
      } else {
        this.setState({ dateError: 'Invalid datetime.' });
      }
    } else {
      this.setState({
        purchaseDate: Moment(purchaseDate).format('MM/DD/YYYY'),
      });
      if (
        Moment(purchaseDate, 'MM/DD/YYYY', true).isValid() ||
        purchaseDate === ''
      ) {
        this.setState({ dateError: null });
      } else {
        this.setState({ dateError: 'Invalid datetime.' });
      }
    }
  };

  onClickToEditEmail = () => {
    this.setState({
      emailCheckType: null,
      userData: null,
    });
  };

  onCheckEmail = () => {
    const { email } = this.state;
    if (this.onValidateEmail(email)) {
      this.props.dispatch({
        type: LotActionType.CHECK_HOMEOWNER_EXISTING_BY_EMAIL_ASYNC,
        params: {
          lotId: this.props.lotProfile.id,
          email,
        },
        callback: (type, data) => {
          this.onCallbackCheckEmail(type, data);
        },
      });
    }
  };

  onCallbackCheckEmail = (type, data) => {
    this.setState({
      emailCheckType: type,
      userData: data,
    });
  };

  onEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (this.onValidateEmail(this.state.email)) {
        this.onCheckEmail();
      }
    }
  }

  setPrimaryOwner(e, item) {
    this.setState({
      setPrimaryOwner: !this.state.setPrimaryOwner,
      openSelectCheckBox: !this.state.openSelectCheckBox,
    });
    this.props.dispatch({
      type: LotActionType.RESET_PRIMARY_HOMEOWNER_TO_LOT_ASYNC,
      params: {
        lotId: this.props.lotProfile.id,
        data: {
          ownerId: item.homeowner.id,
        },
      },
    });
  }

  onCheckHomeowner = (e, item) => {
    item.allWarrantyDataAccess === true
      ? this.props.dispatch({
          type: LotActionType.SET_ALL_WARRANTY_ACCESS_TO_HOMEOWNER_ASYNC,
          params: {
            lotId: this.props.lotProfile.id,
            data: {
              ownerId: item.homeowner.id,
              allWarrantyDataAccess: false,
            },
          },
        })
      : this.props.dispatch({
          type: LotActionType.SET_ALL_WARRANTY_ACCESS_TO_HOMEOWNER_ASYNC,
          params: {
            lotId: this.props.lotProfile.id,
            data: {
              ownerId: item.homeowner.id,
              allWarrantyDataAccess: true,
            },
          },
        });
    this.setState({
      enableHomeownerRequest: !this.state.enableHomeownerRequest,
      openSelectCheckBox: !this.state.openSelectCheckBox,
    });
  };

  onCheckHomeownerPrimary = (e, item) => {
    item.allWarrantyDataAccess === true
      ? this.props.dispatch({
          type: LotActionType.SET_ALL_WARRANTY_ACCESS_TO_HOMEOWNER_ASYNC,
          params: {
            lotId: this.props.lotProfile.id,
            data: {
              ownerId: item.homeowner.id,
              allWarrantyDataAccess: false,
            },
          },
        })
      : this.props.dispatch({
          type: LotActionType.SET_ALL_WARRANTY_ACCESS_TO_HOMEOWNER_ASYNC,
          params: {
            lotId: this.props.lotProfile.id,
            data: {
              ownerId: item.homeowner.id,
              allWarrantyDataAccess: true,
            },
          },
        });
    this.setState({
      enableHomeownerRequest: !this.state.enableHomeownerRequest,
      contextMenuPrimaryKey: !this.state.contextMenuPrimaryKey,
    });
  };

  onUpdatePurchaseDate = () => {
    setTimeout(() => {
      if (
        this.state.purchaseDate !== '' &&
        Moment(this.state.purchaseDate).format('MM/DD/YYYY') !==
          Moment(this.props.lotProfile.lotOwnerships[0].purchaseDate).format(
            'MM/DD/YYYY'
          ) &&
        !this.state.dateError
      ) {
        this.props.dispatch({
          type: LotActionType.UPDATE_PURCHASE_DATE_TO_LOT_ASYNC,
          params: {
            lotId: this.props.lotProfile.id,
            data: {
              purchaseDate: this.state.purchaseDate,
            },
          },
        });
      }
      if (this.state.purchaseDate === '') {
        this.setState({
          purchaseDate: this.props.lotProfile.lotOwnerships[0].purchaseDate
            ? Moment(
                this.props.lotProfile.lotOwnerships[0].purchaseDate
              ).format('MM/DD/YYYY')
            : null,
        });
      }
      this.setState({
        isFocusPurchaseDate: false,
      });
    }, 100);
  };

  onErrorPhoneNumber = (status) => {
    this.setState({
      errorPhoneNumber: status,
    });
  };

  onErrorDaytimePhoneNumber = (status) => {
    this.setState({
      errorDaytimePhoneNumber: status,
    });
  };

  onCheckHomeownerRequest = () => {
    this.setState({
      enableHomeownerRequest: !this.state.enableHomeownerRequest,
    });
  };

  renderHomeownerList = () => {
    const { lotOwnerships } = this.props.lotProfile;
    return lotOwnerships.map((item, index) => {
      return (
        <div id='box' className='row' style={{ marginBottom: 10 }} key={index}>
          <div className='col-sm-6'>
            <span
              style={{
                paddingLeft: 6,
                fontWeight: 600,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                marginRight: 10,
              }}
            >
              {`${item.homeowner.firstName} ${item.homeowner.lastName}`}
            </span>
            <span
              style={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                marginRight: 10,
              }}
            >
              ({item.homeowner.email})
            </span>
            <span
              style={{
                fontSize: 22,
                verticalAlign: 'middle',
                position: 'relative',
              }}
            >
              {item.isPrimary ? (
                <span>
                  <i className='pe-7s-key' />
                  <span
                    className='glyphicon glyphicon-option-vertical cls-table-black-icon'
                    onClick={() => {
                      if (this.state.ctxMenuList2[item.homeowner.id]) {
                        this.setState({ ctxMenuList2: {}, ctxMenuList: {} });
                      } else {
                        setTimeout(() => {
                          this.setState({
                            ctxMenuList2: { [item.homeowner.id]: true },
                          });
                        }, 100);
                      }
                      this.setState({
                        isDisplayCtxMenu: true,
                        contextMenuPrimaryKey: true,
                        openSelectCheckBox: false,
                      });
                    }}
                  />
                </span>
              ) : (
                <span
                  className='glyphicon glyphicon-option-vertical cls-table-black-icon'
                  onClick={() => {
                    if (this.state.ctxMenuList[item.homeowner.id]) {
                      this.setState({ ctxMenuList: {} });
                    } else {
                      setTimeout(() => {
                        this.setState({
                          ctxMenuList: { [item.homeowner.id]: true },
                        });
                      }, 100);
                    }
                    this.setState({
                      isDisplayCtxMenu: true,
                      openSelectCheckBox: true,
                      contextMenuPrimaryKey: false,
                    });
                  }}
                />
              )}
              {this.state.ctxMenuList[item.homeowner.id] &&
                this.state.openSelectCheckBox && (
                  <span
                    id='select-list-current-ownership'
                    className='current-ownership-ctxMenu'
                  >
                    <CheckBoxSingle
                      onChecked={(e) => this.setPrimaryOwner(e, item)}
                      ref={(c) => {
                        this.check = c;
                      }}
                      label='Primary homeowner'
                      className='checkbox-default'
                    />
                    <CheckBoxSingle
                      checked={!item.allWarrantyDataAccess}
                      onChecked={(e) => this.onCheckHomeowner(e, item)}
                      ref={(c) => {
                        this.check = c;
                      }}
                      label='Only requests created after purchase date are visible to this homeowner'
                      className='checkbox-default'
                    />
                  </span>
                )}
              {this.state.ctxMenuList2[item.homeowner.id] &&
                this.state.contextMenuPrimaryKey && (
                  <span
                    id='select-list-current-ownership2'
                    className='current-ownership-ctxMenu'
                  >
                    <CheckBoxSingle
                      checked={!item.allWarrantyDataAccess}
                      onChecked={(e) => this.onCheckHomeownerPrimary(e, item)}
                      ref={(c) => {
                        this.check = c;
                      }}
                      label='Only requests created after purchase date are visible to this homeowner'
                      className='checkbox-default'
                    />
                  </span>
                )}
            </span>
          </div>
        </div>
      );
    });
  };

  renderSetNewOwner = () => {
    const { emailCheckType, errorPhoneNumber, errorDaytimePhoneNumber } =
      this.state;

    const disabled =
      !emailCheckType || errorPhoneNumber || errorDaytimePhoneNumber;

    return (
      <div
        style={{
          padding: 15,
          border: '1px solid #ccc',
          marginBottom: 20,
          marginTop: -5,
          borderRadius: 2,
        }}
      >
        {this.state.emailCheckType === 3 && (
          <Form
            className='form-horizontal'
            ref={(ref) => {
              this.form = ref;
            }}
            onSubmit={this.onSubmit}
          >
            <div className='row'>
              <div className='form-group col-sm-8'>
                <label className='col-sm-12'>
                  Email address <span className='text-danger'>*</span>
                  <OverlayTrigger placement='top' overlay={this.toolTip()}>
                    <i
                      className='fa fa-question-circle'
                      style={{ marginLeft: 10 }}
                    />
                  </OverlayTrigger>
                </label>
                <div className='col-sm-6' style={{ paddingLeft: 15 }}>
                  <span>{this.state.userData.email}</span>
                  <i
                    className='fa fa-pencil email-block-edit-btn'
                    onClick={this.onClickToEditEmail}
                  />
                </div>
              </div>

              <div className='row' style={{ margin: 0 }}>
                <div
                  className='form-group col-sm-6'
                  style={{ paddingLeft: 15 }}
                >
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label
                      className='col-sm-12'
                      style={{ fontWeight: 'normal' }}
                    >
                      First name <span className='text-danger'>*</span>
                    </label>
                    <Input
                      type='text'
                      name='firstName'
                      ref='firstName'
                      className='form-control'
                      max='40'
                      maxLength='40'
                      validations={[Vali.required, Vali.maxlength]}
                      divStyle={{ paddingLeft: 15 }}
                    />
                  </div>
                </div>
                <div
                  className='form-group col-sm-6'
                  style={{ paddingLeft: 15 }}
                >
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label
                      className='col-sm-12'
                      style={{ paddingLeft: 6, fontWeight: 'normal' }}
                    >
                      Last name <span className='text-danger'>*</span>
                    </label>
                    <Input
                      type='text'
                      name='lastName'
                      ref='lastName'
                      className='form-control'
                      max='40'
                      maxLength='40'
                      validations={[Vali.required, Vali.maxlength]}
                      divStyle={{ paddingLeft: 6 }}
                    />
                  </div>
                </div>
              </div>
              <div className='row' style={{ margin: 0 }}>
                <div
                  className='form-group col-sm-6'
                  style={{ paddingLeft: 15 }}
                >
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label
                      className='col-sm-12'
                      style={{ fontWeight: 'normal' }}
                    >
                      Phone number
                    </label>
                    <PhoneNumberInput
                      ref={(ref) => {
                        this.phoneNumber = ref;
                      }}
                      onError={this.onErrorPhoneNumber}
                      divStyle={{ paddingLeft: 15 }}
                    />
                  </div>
                </div>
                <div
                  className='form-group col-sm-6'
                  style={{ paddingLeft: 15, paddingRight: 6 }}
                >
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label
                      className='col-sm-12'
                      style={{ paddingLeft: 6, fontWeight: 'normal' }}
                    >
                      Daytime phone number
                    </label>
                    <PhoneNumberInput
                      ref={(ref) => {
                        this.daytimePhoneNumber = ref;
                      }}
                      onError={this.onErrorDaytimePhoneNumber}
                      divStyle={{ paddingLeft: 6 }}
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-8 col-lg-8 col-xs-8'>
                  <CheckBoxSingle
                    checked={this.state.enableHomeownerRequest}
                    onChecked={this.onCheckHomeownerRequest}
                    ref={(c) => {
                      this.check = c;
                    }}
                    label='Only requests created after purchase date are visible to this homeowner.'
                    className='checkbox-default'
                    style={{ marginLeft: '15px' }}
                  />
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='form-group col-sm-8'>
                <div className='col-sm-12' style={{ marginTop: 10 }}>
                  <span
                    className='btn btn-primary btn-siteone-default'
                    onClick={() =>
                      this.setState({
                        isSettingNewOwner: false,
                        emailCheckType: null,
                        email: '',
                      })
                    }
                  >
                    Cancel
                  </span>
                  <Submit
                    className='btn btn-primary btn-info btn-siteone'
                    disabled={disabled}
                  >
                    Save
                  </Submit>
                </div>
              </div>
            </div>
          </Form>
        )}
        {(this.state.emailCheckType === 2 || this.state.emailCheckType === 1) &&
          this.state.userData && (
            <div>
              <div className='row'>
                <div className='form-group col-sm-8'>
                  <label className='col-sm-12' style={{ paddingLeft: 6 }}>
                    Email address <span className='text-danger'>*</span>
                    <OverlayTrigger placement='top' overlay={this.toolTip()}>
                      <i
                        className='fa fa-question-circle'
                        style={{ marginLeft: 10 }}
                      />
                    </OverlayTrigger>
                  </label>
                  <div className='col-sm-6' style={{ paddingLeft: 6 }}>
                    <span>{this.state.userData.email}</span>
                    <i
                      className='fa fa-pencil email-block-edit-btn'
                      onClick={this.onClickToEditEmail}
                    />
                  </div>
                </div>

                <div className='form-group col-sm-8'>
                  {this.state.emailCheckType === 2 && (
                    <p
                      className='col-sm-12'
                      style={{ fontSize: 14, paddingLeft: 6 }}
                    >
                      The email address{' '}
                      <strong>{this.state.userData.email}</strong> already has
                      an account on SiteOne Services:
                    </p>
                  )}
                  {this.state.emailCheckType === 1 && (
                    <p
                      className='col-sm-12'
                      style={{ fontSize: 14, paddingLeft: 6 }}
                    >
                      The email address{' '}
                      <strong>{this.state.userData.email}</strong> is already
                      associated with this{' '}
                      <Translate translateKey='homeowner' /> account.
                    </p>
                  )}
                </div>
                <div className='form-group col-sm-8'>
                  <div className='block-existing-user'>
                    <Avatar src={null} size={80} />
                    <h4 className='cls-bold'>
                      {this.state.userData.displayName}
                    </h4>
                    <h5>{this.state.userData.email}</h5>
                    <h5>
                      <span style={{ color: '#ccc' }}>Phone number</span>
                      <span
                        style={{
                          fontSize: 16,
                          fontWeight: 600,
                          marginLeft: 15,
                        }}
                      >
                        {this.state.userData.phoneNumber}
                      </span>
                    </h5>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-sm-8'>
                  <div
                    className='col-sm-12'
                    style={{ paddingLeft: 6, marginTop: 10 }}
                  >
                    <span
                      className='btn btn-primary btn-siteone-default'
                      onClick={() =>
                        this.setState({
                          isSettingNewOwner: false,
                          emailCheckType: null,
                          email: '',
                        })
                      }
                    >
                      Cancel
                    </span>
                    <button
                      className='btn btn-primary btn-info btn-siteone'
                      onClick={this.onSubmit}
                      disabled={disabled}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        {this.state.emailCheckType === 0 && this.state.userData && (
          <div>
            <div className='row'>
              <div className='form-group col-sm-8'>
                <label className='col-sm-12' style={{ paddingLeft: 6 }}>
                  Email address <span className='text-danger'>*</span>
                  <OverlayTrigger placement='top' overlay={this.toolTip()}>
                    <i
                      className='fa fa-question-circle'
                      style={{ marginLeft: 10 }}
                    />
                  </OverlayTrigger>
                </label>
                <div className='col-sm-6' style={{ paddingLeft: 6 }}>
                  <span>{this.state.userData.email}</span>
                  <i
                    className='fa fa-pencil email-block-edit-btn'
                    onClick={this.onClickToEditEmail}
                  />
                </div>
              </div>

              <div className='form-group col-sm-8'>
                <p
                  className='col-sm-12'
                  style={{ fontSize: 14, paddingLeft: 6 }}
                >
                  The email address <strong>{this.state.userData.email}</strong>{' '}
                  is this <Translate translateKey='lot' />
                  's current owner.
                </p>
              </div>
              <div className='form-group col-sm-8'>
                <div className='block-existing-user'>
                  <Avatar src={null} size={80} />
                  <h4 className='cls-bold'>
                    {this.state.userData.displayName}
                  </h4>
                  <h5>{this.state.userData.email}</h5>
                  <h5>
                    <span style={{ color: '#ccc' }}>Phone number</span>
                    <span
                      style={{ fontSize: 16, fontWeight: 600, marginLeft: 15 }}
                    >
                      {this.state.userData.phoneNumber}
                    </span>
                  </h5>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-sm-8'>
                <div
                  className='col-sm-12'
                  style={{ paddingLeft: 6, marginTop: 10 }}
                >
                  <span
                    className='btn btn-primary btn-siteone-default'
                    onClick={() =>
                      this.setState({
                        isSettingNewOwner: false,
                        emailCheckType: null,
                        email: '',
                      })
                    }
                  >
                    Cancel
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.emailCheckType === null && (
          <div>
            <div className='row'>
              <div className='form-group col-sm-8'>
                <label className='col-sm-12' style={{ paddingLeft: 6 }}>
                  Email address <span className='text-danger'>*</span>
                  <OverlayTrigger placement='top' overlay={this.toolTip()}>
                    <i
                      className='fa fa-question-circle'
                      style={{ marginLeft: 10 }}
                    />
                  </OverlayTrigger>
                </label>
                <div
                  className='col-sm-6 email-block'
                  style={{ paddingLeft: 6 }}
                >
                  <input
                    type='text'
                    name='email'
                    ref='email'
                    className='form-control'
                    maxLength='256'
                    value={this.state.email}
                    onChange={this.onChangeEmail}
                    onKeyPress={this.onEnter.bind(this)}
                  />
                  <i
                    className={
                      'fa fa-check email-block-check-btn ' +
                      (!this.onValidateEmail(this.state.email)
                        ? 'disabled'
                        : '')
                    }
                    onClick={this.onCheckEmail}
                  />
                </div>
              </div>
            </div>
            <CheckBoxSingle
              checked={this.state.homeownerInvitation}
              onChecked={this.onCheckHOInvitation}
              ref={(c) => {
                this.check = c;
              }}
              label='Send the email invitation to the Homeowner?'
              className='checkbox-default'
              style={{ marginLeft: '5px' }}
            />
            <div className='row'>
              <div className='form-group col-sm-8'>
                <div
                  className='col-sm-12'
                  style={{ paddingLeft: 6, marginTop: 10 }}
                >
                  <span
                    className='btn btn-primary btn-siteone-default'
                    onClick={() =>
                      this.setState({
                        isSettingNewOwner: false,
                        emailCheckType: null,
                        email: '',
                      })
                    }
                  >
                    Cancel
                  </span>
                  <button
                    className='btn btn-primary btn-info btn-siteone'
                    onClick={this.onSubmit}
                    disabled={disabled}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  onSubmit = (e) => {
    e.preventDefault();
    if(!this.state.homeownerInvitation){
      this.setState({ isDisplayHOInvitationModal: true });
    }else{
      this.onEditOwner();
    }
  };
  onEditOwner = () => {
    const { userData, homeownerInvitation } = this.state;
    if (this.state.emailCheckType === 1) {
      const data = {
        ownerId: userData.id,
        IsEmailSend: homeownerInvitation,
      };

      this.props.dispatch({
        type: LotActionType.ADD_MORE_HOMEOWNER_TO_LOT_ASYNC,
        params: {
          lotId: this.props.lotProfile.id,
          data,
        },
        callback: () => {
          this.onBindingLot();
        },
      });
    } else if (this.state.emailCheckType === 2) {
      const { purchaseDate } = this.state;

      const data = {
        purchaseDate: Moment.isMoment(purchaseDate)
          ? formatTimezoneDateTime(purchaseDate)
          : purchaseDate,
        lotId: this.props.lotProfile.id,
        firstName: userData.firstName,
        lastName: userData.lastName,
        phoneNumber: userData.phoneNumber,
        daytimePhoneNumber: userData.daytimePhoneNumber,
        email: userData.email,
        isSetOwnerShip: false,
        IsEmailSend: homeownerInvitation,
      };

      this.props.dispatch({
        type: LotActionType.INVITE_HOMEOWNER_ASYNC,
        params: data,
        callback: () => {
          this.onBindingLot();
        },
      });
    } else if (this.state.emailCheckType === 3) {
      if (this.state.enableHomeownerRequest === false) {
        const formData = this.form.getValues();
        const data = {
          purchaseDate: Moment.isMoment(this.state.purchaseDate)
            ? formatTimezoneDateTime(this.state.purchaseDate)
            : this.state.purchaseDate,
          lotId: this.props.lotProfile.id,
          firstName: formData.firstName,
          lastName: formData.lastName,
          phoneNumber: this.phoneNumber.state.value,
          daytimePhoneNumber: this.daytimePhoneNumber.state.value,
          email: userData.email,
          isSetOwnerShip: false,
          allWarrantyDataAccess: true,
          IsEmailSend: homeownerInvitation,
        };

        this.props.dispatch({
          type: LotActionType.INVITE_HOMEOWNER_ASYNC,
          params: data,
          callback: () => {
            this.onBindingLot();
          },
        });
      } else if (this.state.enableHomeownerRequest === true) {
        const formData = this.form.getValues();

        const data = {
          purchaseDate: Moment.isMoment(this.state.purchaseDate)
            ? formatTimezoneDateTime(this.state.purchaseDate)
            : this.state.purchaseDate,
          lotId: this.props.lotProfile.id,
          firstName: formData.firstName,
          lastName: formData.lastName,
          phoneNumber: this.phoneNumber.state.value,
          daytimePhoneNumber: this.daytimePhoneNumber.state.value,
          email: userData.email,
          isSetOwnerShip: false,
          AllWarrantyDataAccess: false,
          IsEmailSend: homeownerInvitation,
        };

        this.props.dispatch({
          type: LotActionType.INVITE_HOMEOWNER_ASYNC,
          params: data,
          callback: () => {
            this.onBindingLot();
          },
        });
      }
    }
    this.onCheckHOInvitation();
  };
  onCheckHOInvitation = () => {
    this.setState({
      homeownerInvitation: !this.state.homeownerInvitation,
    });
  };
  handleClose = () => {
    this.setState({
      isDisplayHOInvitationModal: false,
        isSettingNewOwner: false,
        emailCheckType: null,
        email: '',
        homeownerInvitation:true
    });
  };
  handleCloseModal=()=>{
    this.setState({
      isDisplayHOInvitationModal: false,
    });
  }
  render() {
    const breadcrumbs = [
      {
        title: 'Ownership info',
        url: '/lots',
        onCustomAction: this.onCustomAction,
      },
      { title: 'Edit current ownership', url: '' },
    ];

    return (
      <div className='lot-info-content' style={{ paddingLeft: 29 }}>
        <div className='row'>
          <div className='form-group col-sm-8' style={{ marginBottom: 0 }}>
            <label
              className='col-sm-12'
              style={{ paddingLeft: 6, fontWeight: 500, fontSize: 15 }}
            >
              Edit current ownership
            </label>
          </div>
        </div>
        <div className='row'>
          <div className='form-group col-sm-8' style={{ marginBottom: 0 }}>
            <div className='col-sm-12' style={{ paddingLeft: 6 }}>
              <Breadcrumb breadcrumbs={breadcrumbs} />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='form-group col-sm-8' style={{ marginBottom: 20 }}>
            <span
              className='col-sm-12'
              style={{ paddingLeft: 6, color: '#9B9B9B', marginBottom: 10 }}
            >
              Purchase date
            </span>
            <label className='col-sm-12' style={{ paddingLeft: 6 }}>
              Purchase date
            </label>
            <div
              className='col-sm-6 ownership-purchase-date-block'
              style={{ paddingLeft: 6 }}
            >
              <Datetime
                ref={(ref) => {
                  this.purchaseDate = ref;
                }}
                name='purchaseDate'
                inputProps={{ placeholder: 'mm/dd/yyyy' }}
                timeFormat={false}
                value={this.state.purchaseDate}
                onChange={(purchaseDate) =>
                  this.onChangePurchaseDate(purchaseDate)
                }
                onFocus={() => this.setState({ isFocusPurchaseDate: true })}
                onBlur={() => this.onUpdatePurchaseDate()}
                />
              {this.state.dateError && (
                <span
                  className='text-danger'
                  style={{ fontSize: 12, marginTop: 5 }}
                >
                  {this.state.dateError}
                </span>
              )}
              {this.state.isFocusPurchaseDate && [
                <button
                  className='ownership-purchase-date-btn ownership-purchase-date-btn--cancel input-over-btn'
                  onMouseDown={() => {
                    this.setState({
                      purchaseDate: Moment(
                        this.props.lotProfile.lotOwnerships[0].purchaseDate
                      ).format('MM/DD/YYYY'),
                      isFocusPurchaseDate: false,
                    });
                  }}
                >
                  <i className='fa fa-close' />
                </button>,
                <button
                  className='ownership-purchase-date-btn ownership-purchase-date-btn--save input-over-btn'
                  onClick={this.onUpdatePurchaseDate}
                >
                  <i className='fa fa-check' />
                </button>,
              ]}
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='form-group col-sm-8' style={{ marginBottom: 5 }}>
            <div
              className='col-sm-12'
              style={{ paddingLeft: 6, color: '#9B9B9B', marginBottom: 10 }}
            >
              <Translate translateKey='homeowner' capitalize plurals />
              <button
                className='btn btn-primary btn-siteone-default'
                style={{ padding: '9px 16px', marginLeft: 15 }}
                onClick={() => this.setState({ isSettingNewOwner: true })}
              >
                <span className='fa fa-plus icon' />
                ADD
              </button>
            </div>
          </div>
        </div>

        {this.state.isSettingNewOwner && this.renderSetNewOwner()}

        {this.renderHomeownerList()}
        <Modal
          show={this.state.isDisplayHOInvitationModal}
          onHide={this.handleCloseModal}
          style={{ top: '20%' }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          {!this.state.homeownerInvitation &&
              <p>
                You have opted out to send homeowner the email invite! Please confirm.
              </p>
            }
          </Modal.Body>
          <Modal.Footer>
            <div className='text-right'>
              <button
                className='btn btn-primary btn-siteone-default'
                onClick={this.handleClose}
              >
                Cancel
              </button>
              <button
                className='btn btn-primary btn-info btn-siteone'
                style={{ marginLeft: 10 }}
                onClick={() => {
                  this.setState(
                    {
                      isDisplayHOInvitationModal: false,
                    },
                    () => {
                      this.onEditOwner();
                    }
                  );
                }}              >
                Confirm
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    LotProfile: state.LotStore.LotProfile,
  };
};

export default connect(mapStateToProps)(EditCurrentOwnership);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-view-ownership-info-edit.js